module.exports = __webpack_public_path__ + "static/media/selec-nft-11.fe4f6a2f.png";